import styled from '@emotion/styled';
import { N100 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var DescriptionBylineStyle = styled.span({
  color: "var(--ds-text-subtlest, ".concat(N100, ")"),
  fontSize: '12px',
  marginTop: "var(--ds-space-025, 2px)",
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});